import React from 'react';
import { Loader } from 'lucide-react';
import { cn } from '../../../lib/utils';

const LoaderFullScreen = () => {
  React.useEffect(() => {
    // Add styles to body when loader is mounted
    document.body.style.margin = '0';
    document.body.style.padding = '0';
    document.body.style.overflow = 'hidden';

    return () => {
      // Cleanup styles when unmounted
      document.body.style.margin = '';
      document.body.style.padding = '';
      document.body.style.overflow = '';
    };
  }, []);

  return (
    <div
      className={cn(
        'h-screen w-screen flex items-center justify-center',
        'bg-background',
        // GPU acceleration
        'transform-gpu',
        'will-change-transform',
      )}
    >
      <div className="transform-gpu will-change-transform">
        <Loader className="h-8 w-8 animate-spin text-muted-foreground/50" />
      </div>
    </div>
  );
};

export default LoaderFullScreen;
